import React from 'react';
import { withStyles } from '@material-ui/styles';
import FormControl from '@material-ui/core/FormControl';

const ValidationFormControl = withStyles((theme) => ({
  root: {
    "& label, label.Mui-focused": {
      color: theme.custom.input.labelActiveColor
    },
    "& label.Mui-error": {
      color: theme.custom.input.errorColor
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: theme.custom.input.borderFocusColor
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.custom.input.errorColor
    }
  }
}))(FormControl);

export default ValidationFormControl;